var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTableSimple',_vm._g(_vm._b({staticClass:"BTablePublicationDataCollections",attrs:{"headers":_vm.headers,"actions":_vm.filteredActions},scopedSlots:_vm._u([{key:"item.form_template",fn:function(ref){
var header = ref.header;
var data = ref.data;
var v = ref.value;
return [(_vm.hasAccessToTemplates)?_c('router-link',{attrs:{"to":header.getRoute(data)},domProps:{"textContent":_vm._s(v)}}):_c('span',{domProps:{"textContent":_vm._s(v)}})]}},{key:"item.is_scannable",fn:function(ref){
var v = ref.value;
return [(v)?_c('v-icon',{attrs:{"color":"success","size":"18"}},[_vm._v(" mdi-check ")]):_c('span',{staticClass:"grey--text text--lighten-1"},[_vm._v("—")])]}}])},'BTableSimple',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }